import axios from 'axios';
import store from '../redux/store/store';
import marketplacesService from './marketplacesService';
import ecommercePlaceService from './ecommercePlaceService';

const API_AUTH_URL = import.meta.env.VITE_API_URL;
const API_REPORTS_URL = import.meta.env.VITE_REPORTS_URL;
const API_OUTWARD_URL = import.meta.env.VITE_OUTWARD_URL;

const orderService = {
  fetchOrders: async (userId, page = 1, pageSize = 10, dateFilter = false, model) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get(`${API_AUTH_URL}/Order`, {
        params: {
          UserId: userId,
          page: page,
          pageSize: pageSize,
          DateFilter: dateFilter,
          withMarketpleace: true,
          WithEcommerce: true,
          WithAddress: true,
          ...model
        },
        headers: { Authorization: `Bearer ${userToken}` }
      });

      return response.data;
    } catch (error) {
      console.error('Error fetching orders:', error);
      throw error;
    }
  },

  fetchOrdersWithProduct: async (userId, page = 1, pageSize = 10, dateFilter = false, model) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;

      const response = await axios.get(`${API_AUTH_URL}/Order`, {
        params: {
          UserId: userId,
          page: page,
          pageSize: pageSize,
          DateFilter: dateFilter,
          withMarketpleace: true,
          WithEcommerce: true,
          WithAddress: true,
          WithProduct: true,
          ...model
        },
        headers: { Authorization: `Bearer ${userToken}` }
      });

      return response.data;
    } catch (error) {
      console.error('Error fetching orders:', error);
      throw error;
    }
  },

  fetchOrdersReports: async (query) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get(`${API_REPORTS_URL}/order/Order`, {
        params: {
          UserId: query.userId,
          tip: query.type,
          startDate: query.startDate,
          endDate: query.endDate
        },
        headers: { Authorization: `Bearer ${userToken}` }
      });

      return response.data;
    } catch (error) {
      console.error('Error fetching orders:', error);
      throw error;
    }
  },

  updateOrder: async (updatedData) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.put(
        `/Order`,
        updatedData,
        {
          headers: {
            Authorization: `Bearer ${userToken}`
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Ürün güncellenirken bir hata oluştu:", error);
      if (error.response && error.response.data) {
        console.error("Hata yanıtı:", error.response.data);
      }
      throw error;
    }
  },

  updateOrderCargo: async (marketPlace, data) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const userId = store.getState()?.auth?.user?.id;

      console.log("Başlangıç data:", data);

      if (!data?.cargoCompanyId) {
        throw new Error("Kargo firma ID'si bulunamadı");
      }
      const orderDetailsPromises = await axios.get(`${API_AUTH_URL}/Order`, {
        params: {
          UserId: userId,
          Id: data.orderId,
          withMarketpleace: true,
          WithEcommerce: true,
          WithAddress: true,
          WithProduct: true
        },
        headers: { Authorization: `Bearer ${userToken}` }
      });
      const orderDetails = orderDetailsPromises?.data?.data?.data[0];


      // Marketplace ve ecommerce settings'i al
      const [marketplaceSettingsResponse, ecommerceSettingsResponse] = await Promise.all([
        marketplacesService.getMarketPlacesAccountsApi(userId, userToken),
        ecommercePlaceService.getEcommercePlaceAccountsApi(userId, userToken)
      ]);

      // Tek sipariş için kargo değişikliği yap
      if (!orderDetails?.orderLines?.[0]?.lineId) {
        throw new Error(`Sipariş detayları eksik: ${orderDetails?.orderId}`);
      }
      // Tüm sipariş satırları için kargo değişikliği yap
      if (!orderDetails?.orderLines || orderDetails.orderLines.length === 0) {
        throw new Error(`Sipariş detayları eksik veya orderLines boş: ${orderDetails?.orderId}`);
      }

      // HepsiBurada ise tüm orderLine'ları döngü ile işle
      if (marketPlace.toLowerCase() === 'hepsiburada') {
        const results = [];

        for (const orderLine of orderDetails.orderLines) {
          if (!orderLine?.lineId) {
            console.warn(`OrderLine ID eksik, atlanıyor: ${orderLine}`);
            continue;
          }
          const requestBody = {
            orderId: orderDetails.orderId.toString(),
            shipmentPackageId: orderLine.packageNumber,
            cargoProvider: data.cargoCompanyId,
            providerName: data.providerName,
            orderLineId: orderLine.lineId,
            marketPlaceSetting: marketplaceSettingsResponse.data.data.data,
            ecommercePlaceSettings: ecommerceSettingsResponse.data.data.data
          };

          try {
            const result = await axios.post(
              `${API_OUTWARD_URL}/OutWard/MarketPlace/${marketPlace}/CargoOrderChange`,
              requestBody,
              {
                headers: {
                  Authorization: `Bearer ${userToken}`
                }
              }
            );

            results.push({
              orderLineId: orderLine.lineId,
              success: true,
              data: result.data
            });
          } catch (error) {
            console.error(`OrderLine ${orderLine.lineId} için kargo değişikliği başarısız:`, error);
            results.push({
              orderLineId: orderLine.lineId,
              success: false,
              error: error.message
            });
          }
        }

        return results;
      } else {
        const requestBody = {
          orderId: orderDetails.orderId.toString(),
          //shipmentPackageId: orderDetails?.orderLines[0]?.packageNumber,
          cargoProvider: data.cargoCompanyId,
          providerName: data.providerName,
          //orderLineId: data.orderLineId,
          marketPlaceSetting: marketplaceSettingsResponse.data.data.data,
          ecommercePlaceSettings: ecommerceSettingsResponse.data.data.data
        };

        const result = await axios.post(
          `${API_OUTWARD_URL}/OutWard/MarketPlace/${marketPlace}/CargoOrderChange`,
          requestBody,
          {
            headers: {
              Authorization: `Bearer ${userToken}`
            }
          }
        );

        return result;
      }
    } catch (error) {
      console.error("Kargo değişikliği yapılırken hata oluştu:", error);
      if (error.response && error.response.data) {
        console.error("Hata yanıtı:", error.response.data);
      }
      throw error;
    }
  }
};

export default orderService;